<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <h1 style="text-align: center;">Create a Tag</h1>

  <div  mat-dialog-content style="
      display: flex;
      flex-direction: column;
      align-content: center;
      flex-wrap: wrap;
      justify-content: space-around;">

    <div style="width: 100%;">
        <div style="width:100%;">
        <mat-form-field style="width:100%;">
          <mat-label>Display Name</mat-label>
          <input matInput formControlName="displayname">
        </mat-form-field>
        </div>

        <div style="width:100%;">
        <mat-form-field style="width:100%;">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description">
        </mat-form-field>
        </div>

        <div style="width:100%;">
        <mat-form-field style="width:100%;">
          <mat-label>Tag Types (MF / SF / GPS)</mat-label>
          <mat-select multiple formControlName="tagtypes">
            <mat-option *ngFor="let t of tagTypeOptions" [value]="t">{{t}}</mat-option>
          </mat-select>
          <mat-hint>Controls which tags appear under the MF / SF / GPS filter. Leave blank for untyped.</mat-hint>
        </mat-form-field>
        </div>

        <div style="width:100%; margin-top:1.5em;">
        <mat-form-field style="width:100%;">
          <mat-label>Type</mat-label>
          <textarea matInput formControlName="type"></textarea>
        </mat-form-field>
        </div>

        <div style="width:100%;">
        <mat-form-field style="width:100%;">
          <mat-label>Status</mat-label>
          <input matInput formControlName="status">
        </mat-form-field>
        </div>
    </div>

    <button type="submit">Submit</button>

  </div>

</form>
